import { memo, useCallback } from "react";
import type { FieldRenderInputProps } from "../../types";
import type { BaseFieldProps } from "./BaseField";
import { BaseField } from "./BaseField";

export const HiddenField = memo(
  ({ fieldId, field, className, "data-testid": testId }: BaseFieldProps) => {
    // 入力レンダリング関数
    const renderInput = useCallback((props: FieldRenderInputProps) => {
      // 入力値を文字列に変換
      const stringValue = props.value !== undefined ? String(props.value) : "";

      return (
        <input
          type="hidden"
          id={props.id}
          name={props.name}
          value={stringValue}
          onChange={(e) => props.onChange(e.target.value)}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          disabled={props.disabled}
          readOnly={props.readOnly}
          required={props.required}
          data-testid={props["data-testid"] || "hidden-field"}
        />
      );
    }, []);

    return (
      <BaseField
        fieldId={fieldId}
        field={field}
        className={className}
        data-testid={testId}
        renderInput={renderInput}
      />
    );
  },
);

HiddenField.displayName = "HiddenField";
